/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Terms_Tooltip1Inputs */

const en_coinvestments_terms_tooltip1 = /** @type {(inputs: Coinvestments_Terms_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign the NDA to view terms`)
};

/**
* | output |
* | --- |
* | "Sign the NDA to view terms" |
*
* @param {Coinvestments_Terms_Tooltip1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_terms_tooltip1 = /** @type {((inputs?: Coinvestments_Terms_Tooltip1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Terms_Tooltip1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_terms_tooltip1(inputs)
});
export { coinvestments_terms_tooltip1 as "coInvestments_terms_tooltip" }